/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_STOCK_URL, COMMON_HEADER_CONFIG} from "../config";

class StockService {
  getAccessToken = () => localStorage.getItem("accessToken");

  searchStocks = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_STOCK_URL}/stocks`,
        params: {
          per_page: 10,
          page: 1,
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListStocks = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_STOCK_URL}/stocks`,
        params: {
          size: 100,
          page: 1
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createStock = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = data;
      dataCreate.selling_quantity = Number(dataCreate.selling_quantity);
      dataCreate.reserved_quantity = Number(dataCreate.reserved_quantity);
      dataCreate.status = "Normal";

      const config = {
        method: "post",
        url: `${API_STOCK_URL}/stock`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataCreate
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateStock = (data) =>
    new Promise((resolve, reject) => {
      const dataUpdate = data;
      dataUpdate.selling_quantity = Number(dataUpdate.selling_quantity);
      dataUpdate.reserved_quantity = Number(dataUpdate.reserved_quantity);

      const config = {
        method: "put",
        url: `${API_STOCK_URL}/stock/update-by-admin-portal/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataUpdate
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.message);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getStock = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_STOCK_URL}/stock/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteStock = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_STOCK_URL}/stock/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data.code === 1 || response.data.code === "success") {
            resolve(response.data.code);
          } else {
            reject(response.data.code);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getStocksHistory = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_STOCK_URL}/stock-process/stock-history`,
        params: {
          per_page: 800,
          page: 1,
          sort: "created_at desc",
          stock_id: id
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const stockService = new StockService();

export default stockService;
